import React from "react";
import { PASSWORD_POLICY_HINT } from "../../../../Utils/utils";

function PasswordPolicyHint({ className = "" }) {
	return <p className={`p-2 text-xs leading-5 text-left rounded-md bg-info text-infoText ${className}`}>{PASSWORD_POLICY_HINT}</p>;
}

export default PasswordPolicyHint;
